type AccountCreationError = {
  message: string;
};

const accountCreationError: AccountCreationError = {
  message: "",
};

export type { AccountCreationError };

export { accountCreationError };
